module.exports = __webpack_public_path__ + "static/media/loader.8aaad2ed.svg";